<template>
    <div class="bigDiv">
        <breadcrumb></breadcrumb> 
        <div class="h-piece">    
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2">
                    <h1>项目信息</h1>
                </div>
                <div class="pieceCon">
                <div class="h-pieceCon2">
                    <div class="h-formLine">
                        <el-form :model="formLabelAlign" label-position="right" :rules="rules" ref="formLabelAlign" :inline="true"  class="demo-ruleForm h-formbLine">
                        <el-form-item label="项目名称" class="h-elformWrap-2" >
                            <el-input v-model="formLabelAlign.contactInfo" placeholder="自带出"></el-input>
                        </el-form-item>
                        <el-form-item label="投标方式" class="h-elformWrap-2" >
                            <el-input v-model="formLabelAlign.contactInfo" placeholder="请选择"></el-input>
                        </el-form-item>
                       <el-form-item label="开标日期" class="h-elformWrap-2">
                            <el-select v-model="formLabelAlign.type" placeholder="请选择">
                                <el-option label="类型一" value="type1"></el-option>
                                <el-option label="类型二" value="type2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="保修期" class="h-elformWrap-2">
                            <el-select v-model="formLabelAlign.type" placeholder="请选择">
                                <el-option label="类型一" value="type1"></el-option>
                                <el-option label="类型二" value="type2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="付款方式" class="h-elformWrap-2" >
                            <el-input v-model="formLabelAlign.contactInfo" placeholder="请输入   %(预付)"></el-input>
                            <el-input v-model="formLabelAlign.contactInfo" placeholder="请输入   %(首款)"></el-input>
                            <el-input v-model="formLabelAlign.contactInfo" placeholder="请输入   %(中款)"></el-input>
                            <el-input v-model="formLabelAlign.contactInfo" placeholder="请输入   %(尾款)"></el-input>
                        </el-form-item>
                        <br>
                        <el-form-item label="到期" class="h-elformWrap-2" >
                            <el-input  placeholder="请输入   天(预付)"></el-input>
                            <el-input  placeholder="请输入   天(预付)"></el-input>
                            <el-input  placeholder="请输入   天(预付)"></el-input>
                            <el-input  placeholder="请输入   %(预付)"></el-input>
                        </el-form-item>
                        <br>
                       <el-form-item label="项目背景" class="h-elformWrap-2">
                            <el-input v-model="formLabelAlign.contactInfo" placeholder="请输入"></el-input>
                            <el-input v-model="formLabelAlign.contactInfo" placeholder=""></el-input>
                        </el-form-item>
                        <br>
                        <el-form-item label="终端成交" class="h-elformWrap-2">
                            <el-select v-model="formLabelAlign.type" placeholder="请选择">
                                <el-option label="类型一" value="type1"></el-option>
                                <el-option label="类型二" value="type2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="专营商毛利率" class="h-elformWrap-2" >
                            <el-input v-model="formLabelAlign.contactInfo" placeholder="公式计算"></el-input>
                        </el-form-item>
                       
                        </el-form>
                    </div>
                </div>
                </div>
            </div>
            <!-- <el-row>
                <el-button style="background-color:blue;">计算</el-button>
                <el-button>取消</el-button>
            </el-row> -->
        </div>
        <div class="h-table">
        <el-table
			 ref="multipleTable"
			 @selection-change="handleSelectionChange"
			:data="tableData2"
			stripe
			:border="true"
			style="width: 100%"
			>
			<el-table-column
              prop="xinxi"
			  type="index"
			  label="分类"
			  width="50">
			</el-table-column>
			<el-table-column
			  label="科目"
			  :show-overflow-tooltip="true"
			  width="100">
			</el-table-column>
            <el-table-column
			  label="说明"
			  :show-overflow-tooltip="true"
			  width="100">
			</el-table-column>
			<el-table-column
			  prop="status"
			  label="标准/单台"
			  :show-overflow-tooltip="true"
			  width="120">
			</el-table-column>
			<el-table-column
			  prop="type"
			  label="合计-率"
			  width="120">
			</el-table-column>
			<el-table-column
			  prop="time"
			  label="型号"
			  :show-overflow-tooltip="true"
			  width="250">
			</el-table-column>
			<el-table-column
			  prop="型号2"
			  label="回款时间"
			  :show-overflow-tooltip="true"
			  width="250">
			</el-table-column>
			<el-table-column
			  prop="customer"
			  label="型号3"
			  :show-overflow-tooltip="true"
			  width="120">
			</el-table-column>
			<el-table-column
             label="操作"
             fixed="right"> 
			</el-table-column>
		  </el-table>
    </div>
    </div>
</template>
<style scoped>

    h6 > span{
        color:greenyellow;
    }
    h6 > .span{
        color: rgba(233, 161, 52, 0.925);
    }
</style>

<script>
export default {
    methods:{
		handleSelectionChange(val) {
			this.multipleSelection = val;
		  }
	},
    data(){
         
      return{
          multipleSelection: [],
          tableData2: [{
                hnumber: 'GH897456666',
                status:'待认领',
                type: '预付回款',
                time: '2019-09-20 16:30:22',
                time2: '2019-09-21 16:30:22',
                customer: '青岛大学附属医院'
            },{
                hnumber: 'GH897456666',
                status:'已认领',
                type: '预付回款',
                time: '2019-09-20 16:30:22',
                time2: '2019-09-21 16:30:22',
                customer: '青岛大学附属医院'
            }, {
                hnumber: 'GH897456666',
                status:'认领中',
                type: '预付回款',
                time: '2019-09-20 16:30:22',
                time2: '2019-09-21 16:30:22',
                customer: '青岛大学附属医院'
            }, {
                hnumber: 'GH897456666',
                status:'待认领',
                type: '预付回款',
                time: '2019-09-20 16:30:22',
                time2: '2019-09-21 16:30:22',
                customer: '青岛大学附属医院',
                xinxi:'信息'
            }],
       formInline: {
            user: '',
            region: '',
            date1: '',
            date2: '',
            date3: '',
        },
        formLabelAlign: {
            name: '',
            contact:'',
            contactInfo:'',
            type: '',
            date3: '',
            explain:''
        },
        rules: {
            name: [
            { required: true, message: '请输入项目名称', trigger: 'blur' },
            ],
        }
      }
    },
}
</script>


